import React from 'react';
import PageDialogOverlay from 'components/PageDialogOverlay';
import ResponsibleGamingContent from 'components/ResponsibleGamingContent';

function ResponsibleGamingPage() {
  return (
    <PageDialogOverlay
      parentClassName="responsible-gaming"
      headerTitle="Responsible Gaming"
      pageTitle="Responsible Gaming"
      backButtonText="Support"
      backLocation="/support"
      scrolling
    >
      <ResponsibleGamingContent />
    </PageDialogOverlay>
  );
}

export default ResponsibleGamingPage;
